export default __webpack_public_path__ + "static/media/cart.5abfa1ff.svg";